import { Page } from './page';

class PageCreate extends Page {
  constructor() {
    super('stories/create');
  }

  protected onLoaded(): void {
    const button = document.getElementById('start-btn') as HTMLButtonElement;
    const form = document.getElementById(
      'create-story-form'
    ) as HTMLFormElement;

    form.addEventListener('submit', (e: Event) => {
      button.disabled = true;
    });
  }
}

new PageCreate();
